/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo, useCallback, useState } from 'react';

import { Stack, Typography } from '@mui/material';

import { i18n } from '../i18n';
import { ApiClientError } from '../types/api/ApiClientError';

type Props = { error: ApiClientError };

export const ReportableApiError = memo((props: Props) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = useCallback(() => setOpen(prev => !prev), [setOpen]);

  if (!props.error) {
    return null;
  }

  return (
    <Stack>
      <Typography variant="body1">{i18n.t<string>('common:reportable_error.title')}</Typography>
      <Typography variant="subtitle2">
        {i18n.t<string>(
          `common:reportable_error.codes.${props.error.response?.data.message}`,
          i18n.t<string>(`common:reportable_error.codes._fallback`) + props.error.response?.data.message,
        )}
      </Typography>

      <Typography variant="subtitle2">{i18n.t<string>('common:reportable_error.call_to_action')}</Typography>

      <Typography variant="caption" onClick={toggleOpen}>
        {i18n.t<string>('common:reportable_error.click_to_show_more')}
      </Typography>
      {open ? (
        <Typography
          variant="caption"
          style={{
            fontFamily: 'monospace',
            whiteSpace: 'pre',
            padding: '8px',
            color: '#444',
            backgroundColor: '#ffffff',
            overflow: 'auto',
            borderRadius: '8px',
          }}
        >
          {JSON.stringify(props.error.response?.data, undefined, 2)}
        </Typography>
      ) : null}
    </Stack>
  );
});
